module.exports = __webpack_public_path__ + "img/Malacca.96e67fa8.png";